import React from "react";

const CommercialDocsIntro = () => {
  return (
    <div className="birthCertHeadContentContainer">
      <h2>
        Introduction to Commercial Documents <span>Attestation</span>
      </h2>
      <p>
        Commercial documents attestation is a crucial process that involves
        verifying the authenticity of various business-related documents for
        international use. This attestation is necessary to ensure that the
        documents are legally recognized in foreign countries, facilitating
        smooth business operations and legal compliance abroad. For businesses
        operating in Bangalore, Goodway Attestation Services provides expert
        assistance in the attestation of commercial documents, ensuring a
        hassle-free and efficient process.
      </p>
    </div>
  );
};

export default CommercialDocsIntro;
